import NextDividend from './components/NextDividend';

export default NextDividend;
